/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorInquiryDto } from '../../models/vendor-inquiry-dto';

export interface VendorInquiryControllerFindAll$Params {
  id: string;
}

export function vendorInquiryControllerFindAll(http: HttpClient, rootUrl: string, params: VendorInquiryControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorInquiryDto>>> {
  const rb = new RequestBuilder(rootUrl, vendorInquiryControllerFindAll.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VendorInquiryDto>>;
    })
  );
}

vendorInquiryControllerFindAll.PATH = '/api/v1/vendorInquiry/{id}/all';
